import React from "react";
import ApplicationsTable from "@/components/tables/ApplicationsTable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCirclePlus,
  faFileCircleCheck,
  faFileCircleQuestion,
} from "@fortawesome/free-solid-svg-icons";
import StatsCard from "@/components/cards/stats/StatsCard";
import SideNavLayout from "@/layouts/SideNavLayout";

const ScreeningsPage = () => {
  return (
    <SideNavLayout>
      <div className="container-fluid">
        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
          <h1 className="page-title fw-semibold fs-18 mb-0 p-2">Screenings</h1>
          <div className="ms-md-1 ms-0">
            <a href="/screenings/new" className="btn btn-success">
              + New Screening
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col col-2">
            <ScreeningFilters />
          </div>
          <div className="col">
            <ApplicationsTable />
          </div>
          {/* <ApplicationStats /> */}
        </div>
      </div>
    </SideNavLayout>
  );
};

const ScreeningFilters = () => {
  return (
    <div className="card">
      <ul className="list-unstyled mail-main-nav px-3 ">
        <li class="px-0 py-2">
          <span class="fs-11 text-muted op-7 fw-semibold">Filters</span>
        </li>
        <li class=" mail-type py-2">
          <a>
            <div class="d-flex align-items-center">
              {/* <i className="bi bi-chat me-2" /> */}
              <span class="flex-fill text-nowrap text-muted ">All</span>
              <span class="badge bg-primary-transparent rounded-pill">6</span>
            </div>
          </a>
        </li>
        <li class="active mail-type py-2">
          <a>
            <div class="d-flex align-items-center">
              {/* <i className="bi bi-chat me-2" /> */}
              <span class="flex-fill text-nowrap text-primary fw-semibold">
                Unread Messages
              </span>
              <span class="badge bg-primary-transparent rounded-pill">6</span>
            </div>
          </a>
        </li>
        <li class="mail-type py-2 ">
          <a>
            <div class="d-flex align-items-center">
              {/* <i className="bi bi-exclamation-triangle me-2" /> */}
              <span class="flex-fill text-nowrap text-muted ">
                Awaiting Descision
              </span>
              <span class="badge bg-primary-transparent rounded-circle">8</span>
            </div>
          </a>
        </li>
        <li class="mail-type py-2 ">
          <a>
            <div class="d-flex align-items-center">
              {/* <i className="bi bi-hourglass me-2" /> */}
              <span class="flex-fill text-nowrap text-muted ">Pending</span>
              <span class="badge bg-primary-transparent rounded-circle">8</span>
            </div>
          </a>
        </li>
        <li class="mail-type py-2 ">
          <a>
            <div class="d-flex align-items-center">
              {/* <i className="bi bi-check me-2" /> */}
              <span class="flex-fill text-nowrap text-muted ">Completed</span>
              <span class="badge bg-primary-transparent rounded-circle">8</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  );
};

const ApplicationStats = () => (
  <div className="row">
    <div className="col">
      <StatsCard
        title="Pending"
        color="dark"
        stat={22}
        icon={<FontAwesomeIcon icon={faFileCirclePlus} />}
      />
    </div>
    <div className="col">
      <StatsCard
        title="In Review"
        stat={33}
        icon={<FontAwesomeIcon icon={faFileCircleQuestion} />}
      />
    </div>
    <div className="col">
      <StatsCard
        title="Awaiting Decision"
        color="warning"
        stat={63}
        icon={<FontAwesomeIcon icon={faFileCirclePlus} />}
      />
    </div>
    <div className="col">
      <StatsCard
        title="Completed"
        color="success"
        stat={65}
        icon={<FontAwesomeIcon icon={faFileCircleCheck} />}
      />
    </div>
  </div>
);

ScreeningsPage.propTypes = {};

export default ScreeningsPage;
